// extracted by mini-css-extract-plugin
export default {"addQuestionButtonWrapper":"bP_8O"};